<template>
    <dx-popup
        v-model:visible="state.generatedPasswordPopupVisible"
        :show-close-button="true"
        width="483px"
        height="210px"
    >
        <div class="h-full flex flex-col justify-between items-center">
            <div class="text-2xl font-medium">Сгенерированный пароль</div>
            <div class="text-center text-[14px]">
                Используйте безопасный сгенерированный пароль или придумайте свой: <b>{{ generatedPassword }}</b>
            </div>
            <div class="w-[80%] flex justify-center gap-3">
                <ai-button
                    class="rounded-md"
                    stylingMode="light-blue"
                    text="Отмена"
                    @click="closePopup"
                />
                <ai-button
                    class="rounded-md"
                    text="Использовать"
                    @click="usePassword"
                />
            </div>
        </div>
    </dx-popup>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { DxPopup } from 'devextreme-vue';
import AiButton from '@/components/ai-button/ai-button.vue';
import { getGeneratedPassword } from '@/service/admin-service.js';
import usersLocalStore from '@/views/administration/users/store.js';

const emit = defineEmits(['onHidden', 'usePassword']);
const generatedPassword = ref('');
const { state } = usersLocalStore;

defineProps({
    isAlertVisible: {
        type: Boolean,
        default: false,
    },
});

onMounted(async () => {
    await generatePassword();
});

const generatePassword = async () => {
    const result = await getGeneratedPassword(state.userRequestBody.user_type_id);
    if (result && result.success) {
        generatedPassword.value = result.data.password;
    }
};

const closePopup = () => {
    state.generatedPasswordPopupVisible = false;
};

const usePassword = () => {
    emit('usePassword', generatedPassword.value);
    closePopup();
};
</script>
